<script lang="ts">
  import { toastStore } from './stores/toast.svelte.js';
  import CircleX from '@lucide/svelte/icons/circle-x';
  import ExternalLink from '@lucide/svelte/icons/external-link';
  import { scale } from 'svelte/transition';
</script>

<!-- z-[100] keeps toasts above the app's drawers/overlays, which sit at z-50
     (DaisyUI's .toast has no z-index of its own). -->
<div class="toast z-[100]">
  {#each toastStore.list as toast (toast.id)}
    <!-- DaisyUI supplies the enter animation; this mirrors it on removal. -->
    <div
      class="flex flex-col alert alert-{toast.type}"
      data-testid={`toast-${toast.type}`}
      out:scale={{ start: 0.9, duration: 250, opacity: 0 }}
    >
      <div class="w-full flex items-center justify-between gap-2">
        <span>{toast.message}</span>
        <div class="flex items-center gap-1">
          {#if toast.link}
            <a
              href={toast.link.href}
              target={toast.link.newTab ? '_blank' : undefined}
              rel={toast.link.newTab ? 'noopener' : undefined}
              class="btn btn-sm btn-ghost"
              data-testid="toast-link"
            >
              {toast.link.label}
              {#if toast.link.newTab}
                <ExternalLink class="size-3.5" aria-hidden="true" />
                <span class="sr-only">(opens in a new tab)</span>
              {/if}
            </a>
          {/if}
          {#if toast.action}
            <button
              class="btn btn-sm btn-ghost cursor-pointer"
              onclick={() => {
                toast.action?.onClick();
              }}
            >
              {toast.action.label}
            </button>
          {/if}
          <button
            class="btn btn-sm btn-circle btn-ghost cursor-pointer"
            onclick={() => {
              toastStore.remove(toast.id);
            }}
            aria-label="Close notification"
          >
            <CircleX class="cursor-pointer" />
          </button>
        </div>
      </div>
      {#if toast.timeoutMs && toast.timeoutMs > 0}
        <div class="w-full h-[2px] items-start -mb-[14px] -mt-1">
          <div
            class="progress-bar h-[2px] w-full bg-base-200"
            style="--duration: {toast.timeoutMs}ms;"
          ></div>
        </div>
      {/if}
    </div>
  {/each}
</div>

<style>
  @keyframes progress-countdown {
    0% {
      width: 100%;
    }
    100% {
      width: 0%;
    }
  }

  .progress-bar {
    width: 100%;
    animation: progress-countdown var(--duration) linear forwards;
  }
</style>
